<template>
    <div class="systembody">
  <div style="margin-top: 10px;">
    <div class="sectionLargeIcon largeServerIcon"></div>
    <div class="widget clearfix">
      <span class="title" style="font-size: 22px; margin-right: 15px; font-weight: 600 !important; color: #183677;">
        לוגים</span>
      <div class="widget_inside" style="margin-top: 15px;">
        <LogsComp />
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import Auth from '@/services/auth.service.js'
import SideMenu from '@/components/widgets/sideMenu.vue'
import TopBar from '@/components/widgets/TopBar'
import LogsComp from '@/components/admin/logs/LogsComp.vue'

export default {
  components: {
    SideMenu,
    LogsComp,
    TopBar,
  },
  data() {
    return {
      isExtended: true,
    };
  },
  methods: {
    openSelected(itemNum) {
      this.itemSelected = itemNum;
    },
    isExtendedFunc() {
      this.isExtended = !this.isExtended;
    }
  },
  created() {
    document.title = 'לוגים | clickcall'
    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
  },
}
</script>
<style scoped>


</style>